import * as S from "./styles.ts";
import { Slider, IncrementButton } from "@template/components";
import useBreakpoint from "@/lib/helpers/hooks/useBreakpoint.ts";
import ToggleSwitch from "@/template/components/ToggleSwitch/index.tsx";
import { useTypedSelector } from "@/redux/helpers/hooks.ts";
import { TBillingInterval } from "@/redux/slices/user/types.ts";

interface ISliderProps {
  value: number;
  setValue: (value: number) => void;
  showInput?: boolean;
  showSlider?: boolean;
  renewalPeriod: string;
  setRenewalPeriod: (value: TBillingInterval) => void;
}

const UserCount = ({
  value,
  setValue,
  showInput,
  showSlider,
  renewalPeriod,
  setRenewalPeriod,
}: ISliderProps) => {
  const { check: isBig, mounted } = useBreakpoint("sm");
  const user = useTypedSelector((state) => state.user.user);

  const handleValue = (val: number) => {
    const min = 1;
    const max = 53;
    return Math.min(Math.max(val, min), max);
  };

  if (!showSlider && !showInput) return;

  return (
    <S.SliderContainer>
      {showInput && (
        <S.Container>
          <S.LabelText>How many users?</S.LabelText>
          <IncrementButton
            value={value}
            setValue={(val) => setValue(handleValue(val))}
            disabled={user?.has_voip && user?.voip_plan !== 8}
          />
        </S.Container>
      )}
      {isBig && mounted && showSlider && (
        <Slider
          value={value}
          onChange={setValue}
          min={1}
          max={53}
          step={1}
          breaks={[20, 50]}
          showNumbers
          startText="1 User"
          showValue
        />
      )}
      <ToggleSwitch
        renewalPeriod={renewalPeriod}
        setRenewalPeriod={setRenewalPeriod}
      />
    </S.SliderContainer>
  );
};

export default UserCount;
